<template>
  <div class="mes-content">
    <div class="mes-content-info">
      <div class="mes-content-info-l">
        <div v-if="proList.items && proList.items.length" style="height:871px;overflow:auto">
          <Row
            v-for="(item,index) in proList.items"
            :key="index"
            class="row-title"
            :class="{rowtitle:index==current}"
            @click.native="getMesId(item,index)"
          >
            <Col style="text-align:left">{{ item.name }}</Col>
            <Col style="text-align:left">{{ item.firstCommentCount }} new message(s)</Col>
          </Row>
        </div>
        <div v-else style="text-align:center;margin-top:50px;">No data</div>
      </div>
      <div class="mes-content-info-r">
        <Row>
          <div v-if="mesList && mesList.items.length" style="height:791px;overflow:auto">
            <div class="mes-content-info-int" v-for="(item,index) in mesList.items" :key="index">
              <div class="mes-content-info-int-top">
                <Col span="15" style="display:flex;">
                  <img
                    :src="item.userInfo.HeadImgUrl"
                    alt="头像"
                    style="width:45px;height:45px;border-radius:50%;"
                  />
                  <div
                    style="display:flex;flex-direction:column;padding-left:20px;justify-content:space-around;"
                  >
                    <span class="s1" style="font-weight:bold;">{{ item.userInfo.NickName }}</span>
                    <!-- <span class="s2" style="font-size:12px;color:#4c4c4c;">总经理</span> -->
                    <span class="s3" style="font-size:12px;color: #4c4c4c;">{{ item.comName }}</span>
                  </div>
                </Col>
                <Col span="7" style="text-align:right;padding-right:40px">
                  <div>{{ item.inTime | dateFormat }}</div>
                </Col>
                <Col span="2" style="display:flex;justify-content:space-around;">
                  <Poptip
                    confirm
                    title="确认是否删除?"
                    @on-ok="delMes(item)"
                    @on-cancel="cancel"
                    placement="bottom"
                  >
                    <span class="btn-del" style="color: #ff0000;cursor: pointer;">Delete</span>
                  </Poptip>
                  <span style="color:#e8e8e8;">|</span>
                  <span
                    class="btn-reply"
                    style="color: #1890ff;cursor: pointer;"
                    @click="item.active = !item.active"
                  >Reply</span>
                </Col>
              </div>
              <div class="mes-content-info-int-bottom">
                <Col
                  span="22"
                  style="word-break:break-all;word-wrap: break-word;padding-right:40px;"
                >{{ item.msgInfo }}</Col>
                <div class="mes-content-info-int-input" v-show="item.active">
                  <Row>
                    <Col span="22">
                      <Input
                        type="textarea"
                        v-model="reply"
                        :autosize="{maxRows:2.5,minRows: 2.5}"
                        style="padding-right: 40px;"
                      />
                    </Col>
                    <Col span="2">
                      <Button type="primary" ghost style="height:40px;" @click="sendMes(item)">发送</Button>
                    </Col>
                  </Row>
                </div>
              </div>
              <Col span="22" style="padding-right:40px;">
                <div
                  class="mes-content-info-int-mes"
                  v-for="(itm,idx) in item.children.items"
                  :key="idx"
                >
                  <span style="color:#1890ff;">回复</span>
                  {{ itm.userInfo.NickName }} : {{ itm.msgInfo }}
                  <div v-if="itm.children && itm.children.items.length > 0">
                    <div v-for="(im,ix) in itm.children.items" :key="ix">
                      {{im.userInfo.NickName}}<span style="color:#1890ff;">回复@</span><span v-if="im.parentUserInfo">{{im.parentUserInfo.NickName}}</span>：{{im.msgInfo}}
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </div>
          <div v-else style="text-align:center;margin-top:50px">No data</div>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      current: 0,
      proList: "",
      reply: "",
      mesList: "",
      mesID: "",

      pageSize: 10,
      pageIndex: 1,
      totalCount: 0
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    })
  },
  methods: {
    ...mapActions({
      getProduct: "productFeedbackModule/getProduct",
      getProductMes: "productFeedbackModule/getProductMes",
      sendProductMes: "productFeedbackModule/sendProductMes",
      delProductMes: "productFeedbackModule/delProductMes"
    }),
    getMesId(id, index) {
      this.mesID = id.id;
      this.current = index;
      this.init();
    },
    async sendMes(data) {
      if (!this.reply) {
        this.$Message.error("回复内容不能为空！");
        return;
      }
      let params = {
        ProId: data.proId,
        CompId: data.compId,
        // UserId: data.userId,
        ParentId: data.id,
        MsgInfo: this.reply
      };
      let result = await this.sendProductMes(params);
      if (result.successed) {
        this.$Message.success("回复成功");
        this.init();
      } else {
        this.$Message.error("回复失败，请重新尝试");
      }
      this.reply = "";
    },
    async delMes(data) {
      let info = await this.delProductMes(data.id);
      if (info.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    cancel() {},
    async init() {
      // 产品列表
      let proList = await this.getProduct({ CompId: this.company.id });
      this.proList = await this.getProduct({
        CompId: this.company.id,
        pageSize: proList.totalCount
      });
      if (this.proList && this.proList.items && this.proList.items.length === 0) return; 

      let option = {
        By: this.mesID || this.proList.items[0].id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
      let data = await this.getProductMes(option);
      if (data && data.items) {
        data.items.map(a => {
          a.active = false; // 回复框状态
          a.comName = this.company.name;
          a.proInfo = a.proInfo ? JSON.parse(a.proInfo) : a.proInfo;
          a.userInfo = a.userInfo ? JSON.parse(a.userInfo) : a.userInfo;
          if (a.children && a.children.items) {
            a.children.items.map(b => {
              b.proInfo = b.proInfo ? JSON.parse(b.proInfo) : b.proInfo;
              b.userInfo = b.userInfo ? JSON.parse(b.userInfo) : b.userInfo;
              if (b.children && b.children.items.length > 0) {
                b.children.items.map(c => {
                  c.proInfo = b.proInfo ? JSON.parse(c.proInfo) : c.proInfo;
                  c.userInfo = c.userInfo ? JSON.parse(c.userInfo) : c.userInfo;
                  c.parentUserInfo = c.parentUserInfo ? JSON.parse(c.parentUserInfo) : c.parentUserInfo;
                })
              }
            });
          }
        });
        this.mesList = data;
        if (this.mesList.items) {
          this.pageSize = this.mesList.pageSize;
          this.pageIndex = this.mesList.pageIndex;
          this.totalCount = this.mesList.totalCount;
        }
        console.log(22222,this.mesList)
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    }
  },
  created() {
    this.init();
  }
};
</script>

<style scoped lang="scss">
.mes-content {
  min-width: 800px;
  padding: 30px;
  &-info {
    width: 100%;
    height: 871px;
    background-color: #fff;
    box-shadow: 0px 0px 7px 0px rgba(146, 160, 185, 0.2);
    display: flex;
    &-l {
      width: 230px;
      text-align: center;
    background-color: #f2f2f2;
    }
    &-r {
      flex: 1;
    }
    &-int {
      border-bottom: 1px solid #e8e8e8;
      margin: 0 30px 0 35px;
      padding: 15px 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &-bottom {
        margin: 10px 0;
      }
      &-input {
        margin-bottom: 20px;
      }
      &-mes {
        background-color: #f2f2f2;
        padding: 5px 0 0 5px;
        word-break: break-all;
        word-wrap: break-word;
      }
    }
  }
}
.row-title {
  background-color: #f2f2f2;
  border-bottom: 1px solid #fff;
  padding: 20px;
  &:hover {
    background-color: #fff;
    cursor: pointer;
  }
}
.rowtitle {
  background-color: #fff;
  border-bottom: 1px solid #e8e8e8;
  padding: 20px;
  &:hover {
    cursor: pointer;
  }
}
.my-page {
  height: 80px;
  padding: 25px;
}
</style>
